import { DateFormats } from 'UI/constants/defaults';
import { localTimeFormatter } from 'UI/utils';

/**
 * Date and time in the local time zone, as V1 shows them (MM/DD/YYYY hh:mm A).
 * @param {string | null} [value] UTC date from the API
 * @returns {string} '' when there is no date
 */
export const formatDateTime = value => localTimeFormatter(value, DateFormats.SimpleDateTime) || '';

/**
 * "City, ST" like V1's ProfileSummary: it needs the city title and the state slug.
 * @param {{ title?: string, state?: { slug?: string } } | null} [city] `address.city` of the API
 * @returns {string | null}
 */
export const formatLocation = city =>
  city?.title && city?.state?.slug ? `${city.title}, ${city.state.slug}` : null;
